module.exports = __webpack_public_path__ + "static/img/Jake_Lever_desktop.819b3ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jake_Lever_desktop.jpg
// module id = PMGW
// module chunks = 0